<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>付费分析(余量)</span>
    </div>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="平台类型" prop="type">
            <el-select
              v-model.number="queryParams.platForm"
              placeholder="请选择类型"
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in platForm"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-tabs v-model="activeName">
          <el-tab-pane v-for="(item, index) in typeArr" :key="index" :label="item.title" :name="item.type">
            <el-row :gutter="24">
              <el-col :span="12">
                <tableData :pay="1" :typ="1" :ftyp="item.type" :title="item.title" :table-data="tableData[item.type]" />
              </el-col>
              <el-col :span="12">
                <tableData :pay="1" :typ="2" :ftyp="item.type" :title="item.title" :table-data="statData[item.type]" />
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span="24">
        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix">
            <span>每日充值</span>
          </div>
          <GoodsData />
        </el-card>
      </el-col>

      <el-col :span="24">
        <el-card style="margin-top: 20px;">
          <IndexUserPayAnalyze />
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getRankData } from '@/api/statistics/user_remain'
import tableData from '@/views/config/rank/components/table.vue'
import GoodsData from '@/views/config/rank/components/goods.vue'
import IndexUserPayAnalyze from '@/components/Index/IndexUserPayAnalyze.vue'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'PayAnalyze',
  components: {
    tableData,
    GoodsData,
    IndexUserPayAnalyze
  },
  data() {
    return {
      loading: false,
      typeArr: [
        { title: '金额', type: 'pay' },
        { title: '等级', type: 'levelId' },
        { title: '金币', type: 'money' },
        { title: '体力', type: 'spins' },
        { title: '星星', type: 'star' },
        { title: '绿钻', type: 'diamond' },
        { title: '野兽币', type: 'beast_coin' }
      ],
      activeName: 'pay',
      platForm: [{ label: '所有', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }],
      statData: [],
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        platForm: 1,
        type: 2
      }
    }
  },
  created() {
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      this.loading = true
      getRankData(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        this.statData = res.data.data.data
        this.tableData = res.data.data.stat
        this.queryParams.startDate = res.data.req.startDate
      })
    }
  }
}
</script>

<style scoped>

</style>
